/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DevSettingDto
 */
export interface DevSettingDto {
    /**
     * 
     * @type {string}
     * @memberof DevSettingDto
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof DevSettingDto
     */
    value: string;
    /**
     * 
     * @type {Date}
     * @memberof DevSettingDto
     */
    createdAt: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof DevSettingDto
     */
    updatedAt: Date | null;
}

/**
 * Check if a given object implements the DevSettingDto interface.
 */
export function instanceOfDevSettingDto(value: object): value is DevSettingDto {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function DevSettingDtoFromJSON(json: any): DevSettingDto {
    return DevSettingDtoFromJSONTyped(json, false);
}

export function DevSettingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DevSettingDto {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'value': json['value'],
        'createdAt': (json['createdAt'] == null ? null : new Date(json['createdAt'])),
        'updatedAt': (json['updatedAt'] == null ? null : new Date(json['updatedAt'])),
    };
}

export function DevSettingDtoToJSON(json: any): DevSettingDto {
    return DevSettingDtoToJSONTyped(json, false);
}

export function DevSettingDtoToJSONTyped(value?: DevSettingDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'value': value['value'],
        'createdAt': (value['createdAt'] == null ? null : (value['createdAt'] as any).toISOString()),
        'updatedAt': (value['updatedAt'] == null ? null : (value['updatedAt'] as any).toISOString()),
    };
}

